import * as React from "react";
import { AlgoliaAnalyticsHelpers, DataLayer } from "@grandvisionhq/analytics";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { monetate } from "@grandvisionhq/svc-monetate";
import { isDefined } from "@grandvisionhq/utils";
import { createImpressionEvent, createImpressionObject, createInteractionEvent } from "../../../Events/DataLayer/Events/ProductListingPageEvents.js";
const usePlpDatalayerEvents = () => {
  const { currency } = useIntl();
  const { isMonetateProductDataEnabled } = useFeatureToggles();
  const impressionEvent = createImpressionEvent(currency);
  const {
    atfEcommerce: {
      ecommerce: { impressions }
    }
  } = impressionEvent;
  const addImpressionEvent = React.useCallback(
    (product, position, indexName) => {
      impressions.push(createImpressionObject(product, position));
      if (indexName) {
        AlgoliaAnalyticsHelpers.sendProductsViewedEvent([product.masterVariant.sku], indexName);
      }
    },
    []
  );
  const trackMonetateImpressions = (products) => {
    monetate().trackProductListing(
      isMonetateProductDataEnabled ? products.filter(isDefined).map((product) => ({
        sku: product.masterVariant.sku || ""
      })) : []
    );
  };
  const pushImpressionsToDatalayer = () => {
    DataLayer.pushEvent(impressionEvent);
  };
  const pushProductClickToDatalayer = React.useCallback(
    (product, position) => {
      DataLayer.pushEvent(
        createInteractionEvent(product, position, `category: ${product.productType}`, currency)
      );
    },
    []
  );
  return {
    addImpressionEvent,
    trackMonetateImpressions,
    pushImpressionsToDatalayer,
    pushProductClickToDatalayer
  };
};
export {
  usePlpDatalayerEvents
};
//# sourceMappingURL=use-plp-datalayer-events.js.map
